// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  listPrivateLinkResources,
  getPrivateLinkResource,
  checkNameAvailability,
  generateCredentials,
  regenerateCredential,
  listCredentials,
  listUsages,
  importImage,
  list,
  listByResourceGroup,
  $delete,
  update,
  create,
  get,
} from "./operations.js";
export {
  type RegistriesListPrivateLinkResourcesOptionalParams,
  type RegistriesGetPrivateLinkResourceOptionalParams,
  type RegistriesCheckNameAvailabilityOptionalParams,
  type RegistriesGenerateCredentialsOptionalParams,
  type RegistriesRegenerateCredentialOptionalParams,
  type RegistriesListCredentialsOptionalParams,
  type RegistriesListUsagesOptionalParams,
  type RegistriesImportImageOptionalParams,
  type RegistriesListOptionalParams,
  type RegistriesListByResourceGroupOptionalParams,
  type RegistriesDeleteOptionalParams,
  type RegistriesUpdateOptionalParams,
  type RegistriesCreateOptionalParams,
  type RegistriesGetOptionalParams,
} from "./options.js";
